import { render, staticRenderFns } from "./DniInput.vue?vue&type=template&id=540f5468"
import script from "./DniInput.vue?vue&type=script&lang=js"
export * from "./DniInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports